module.exports = __webpack_public_path__ + "media/pt_pt_s4_Rodrigo.5fd45002.oga";